import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@components/Header';
import Footer from '@components/Footer';
import ToastContainer, { toastManager } from '@components/Admin/ToastContainer';
import DashboardSection from '@components/Admin/DashboardSection';
import UserManager from '@components/Admin/UserManager';
import VIPManager from '@components/Admin/VIPManager';
import AdsManager from '@components/Admin/AdsManager';
import RedeemManager from '@components/Admin/RedeemManager';
import SettingsSection from '@components/Admin/SettingsSection';
import '@components/Admin/AdminStyles.css';

function Dashboard() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('dashboard');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const adminToken = localStorage.getItem('adminToken');
        if (!adminToken) {
            navigate('/admin-login');
            return;
        }
        
        setLoading(false);
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
        toastManager.success('Logout Successful', 'You have been logged out');
        setTimeout(() => {
            navigate('/admin-login');
        }, 1000);
    };

    const tabs = [
        { id: 'dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
        { id: 'users', icon: 'fa-users', label: 'Users' },
        { id: 'vip', icon: 'fa-crown', label: 'VIP' },
        { id: 'redeem', icon: 'fa-ticket-alt', label: 'Redeem Codes' },
        { id: 'ads', icon: 'fa-ad', label: 'Ads' },
        { id: 'settings', icon: 'fa-cog', label: 'Settings' }
    ];

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a1e, #16213e, #0f0f23)' }}>
                <div style={{ textAlign: 'center', color: '#999' }}>
                    <i className="fas fa-spinner fa-spin" style={{ fontSize: '3rem', color: '#FFD700', marginBottom: '1rem' }}></i>
                    <p>Loading Admin Panel...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-dashboard">
            <Header />

            <main className="admin-main">
                {/* Admin Header */}
                <div className="admin-header">
                    <div className="admin-header-content">
                        <div className="admin-title-section">
                            <h1>
                                <i className="fas fa-shield-alt"></i> 
                                DinoShort Admin Panel
                            </h1>
                            <p className="admin-subtitle">Comprehensive control center for managing your streaming platform</p>
                        </div>
                        
                        <button onClick={handleLogout} className="admin-logout-btn">
                            <i className="fas fa-sign-out-alt"></i> Logout
                        </button>
                    </div>
                    
                    {/* Navigation Tabs */}
                    <div className="admin-nav">
                        {tabs.map(tab => (
                            <button
                                key={tab.id}
                                className={`admin-nav-btn ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                <i className={`fas ${tab.icon}`}></i> {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Content Sections - Lazy Loaded */}
                <div className="admin-content">
                    {(() => {
                        switch (activeTab) {
                            case 'dashboard':
                                return <DashboardSection />;
                            case 'users':
                                return <UserManager />;
                            case 'vip':
                                return <VIPManager />;
                            case 'redeem':
                                return <RedeemManager />;
                            case 'ads':
                                return <AdsManager />;
                            case 'settings':
                                return <SettingsSection />;
                            default:
                                return <DashboardSection />;
                        }
                    })()}
                </div>
            </main>

            <Footer />
            
            {/* Toast Notifications */}
            <ToastContainer />
        </div>
    );
}

export default Dashboard;
